// extracted by mini-css-extract-plugin
export default {"viewCreditBtnContainer":"CreditHistoryModal_viewCreditBtnContainer__VFxEV","headerClass":"CreditHistoryModal_headerClass__UUmWg"};